module.exports = __webpack_public_path__ + "media/img/Landing_Page/S2U-Landing-BG-14df7689895be8210a2f0c011d0dc1e1.svg";